import { getCountryNames } from '@luxuryescapes/lib-countries';

import getAllCurrencyCodes from '~/utils/getAllCurrencyCodes';

export const currencyCodes = getAllCurrencyCodes();

export const countries = getCountryNames();
